export const candidateUpdateSkill = ({ BeURL, id, topInput, setSkillList, showAlert, handleTopClear, setIsUpdating }) => {
    if (!BeURL || !id || !topInput) {
        showAlert("Missing required data to update skill. Please try again.");
        return;
    }
    setIsUpdating(true)
    fetch(`${BeURL}/candidate-update-skill/${id}`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ skills: [topInput] }),
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                if (data.skills) {
                    setSkillList(data.skills)
                   
                }
                handleTopClear()
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log("Error in skills updated", err)
        })
        .finally(() => setIsUpdating(false))
} 
